import type { AnalyticsEvent, AnalyticsParams } from '../events';
import { TrackingDestination } from './TrackingDestination';

/** Tracking for registering events in Google Tag Manager. */
export class GtmDestination extends TrackingDestination {
  protected isEnabled(): boolean {
    return (
      !!import.meta.env.VITE_GTM_ID &&
      import.meta.env.VITE_ENVIRONMENT !== 'dev'
    );
  }

  protected send(event: AnalyticsEvent, payload: AnalyticsParams): void {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...payload });
  }
}
